import React from 'react';
import cx from 'classnames';
import { uid } from 'uid';
import useThemeBlock from '@/hooks/useThemeBlock';
import { InputCheckbox } from '@/components/atoms/Inputs/InputCheckbox/render';
import formBlock from '@/components/molecules/Form/block.json';
import block from './block.json';

import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
type InputYesNoProps = InputProps &
	ThemeProps & {
		value?: string;
		title?: string;
	};

interface ForwardedInputYesNo
	extends React.ForwardRefExoticComponent<
			InputYesNoProps & React.RefAttributes<HTMLDivElement>
		>,
		BlockConfigs {}

/**
 * COMPONENT
 */
export const InputYesNo = React.forwardRef<HTMLInputElement, InputYesNoProps>(
	(
		{
			title,
			id = uid(),
			label,
			name,
			fullSize = true,
			value,
			required = false,
			disabled = false,
			invalid,
			inputAttributes,
			theme = {},
		},
		ref
	) => {
		const { blockTheme: formBlockTheme } = useThemeBlock(
			formBlock.slug,
			theme
		);

		const rootClass = cx(
			'supt-inputYesNo supt-inputWrapper supt-inputField',
			fullSize ? 'supt-inputField--full' : 'supt-inputField--half',
			getStyles(formBlockTheme)
		);

		return (
			<fieldset className={rootClass}>
				{/* TODO: handle data-optional here? */}
				{title ? (
					<legend className="supt-inputYesNo__title">{title}</legend>
				) : null}
				<InputCheckbox
					id={id}
					name={name}
					label={label}
					value={value}
					required={required}
					disabled={disabled}
					invalid={invalid}
					ref={ref}
					{...inputAttributes}
				/>
			</fieldset>
		);
	}
) as ForwardedInputYesNo;

InputYesNo.slug = block.slug;
InputYesNo.title = block.title;
